/** Finds the color of a status by its display label (used when the API only sends the label). */
export function colorForLabel(map, label, fallback = "#94A3B8") {
  const hit = Object.values(map).find((entry) => entry.label === label);
  return hit ? hit.color : fallback;
}

/** "#RRGGBB" -> "rgba(r, g, b, alpha)" for soft tinted backgrounds. */
export function tint(hex, alpha = 0.14) {
  const value = hex.replace("#", "");
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Green when compliance is healthy, amber in the middle, red when it needs work. */
export function complianceColor(pct) {
  if (pct >= 80) return "#10B981";
  if (pct >= 60) return "#F59E0B";
  return "#EF4444";
}
